import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, input } from '@angular/core';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { PlanificadorService } from '../models/control.service';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { valorlatenteinterface } from 'src/app/interface/ValorLatenteInterface';
import { Subscription } from 'rxjs';
import { auditTime } from 'rxjs/operators';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { BrokerService } from 'src/app/services/broker.services';
import { ToastrService } from 'ngx-toastr'; // Añade esta importación al principio del archivo
import { TemaService } from 'src/app/services/tema.services';

@Component({
  selector: 'app-vallatentes',
  templateUrl: './vallatentes.component.html',
  styleUrl: './vallatentes.component.scss'
})
export class VallatentesComponent implements OnInit, OnChanges, OnDestroy {

  public ValLat = new CdkTableVirtualScrollDataSource<valorlatenteinterface>();
  public DivValLat = new CdkTableVirtualScrollDataSource<valorlatenteinterface>();
  public gestValLat = new CdkTableVirtualScrollDataSource<valorlatenteinterface>();
  public brokValLat = new CdkTableVirtualScrollDataSource<valorlatenteinterface>();

  private valLatsubscription: Subscription;
  private DivVallatsub: Subscription;
  private gestValLatSub: Subscription;
  private brokValLatSub: Subscription;
  public dataVal: any[] = [];
  @Input() selectedTab: number = 0;

  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;

  public index: number = 0;
  public fechaSubcription = new Subscription;
  public indexDiv: number = 0;
  public indexGest: number = 0;
  public indexBrok: number = 0;
  public DivfechaSubcription = new Subscription;
  public gestFechaSub = new Subscription;
  public brokFechaSub = new Subscription;
  public subTemaService: Subscription = new Subscription;
  public isDark: boolean = false;

  @Input() tableColumnsLat: TableColmuns[] = [];
  @Input() displayedColumnsLat: string[] = [];

  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportValLat!: CdkVirtualScrollViewport
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportValLatDiv!: CdkVirtualScrollViewport
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportValLatGest!: CdkVirtualScrollViewport
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportValLatBrok!: CdkVirtualScrollViewport


  filaSeleccionada: any;
  queryParams: string;
  contadorFilas: number;

  constructor(public controlService: PlanificadorService,
    public diversificadorsv: DiversificadorService,
    public _gestorsv: GestionService,
    public _broker: BrokerService,
    private toastr: ToastrService,
    private temaservicio: TemaService
  ) {

  }

  ngOnInit(): void {
    // 'vla' llega en lotes cada 200 periodos y trae una fila por posición y día: auditTime agrupa
    // los lotes seguidos (siempre entrega el último) para no rehacer la tabla con cada uno.
    this.valLatsubscription = this.controlService.valoreslatente$.pipe(auditTime(300)).subscribe({
      next: (data: any) => {
        this.dataVal = this.flattenArray(data);
        this.dataVal = this.updateCounter(this.dataVal);
        this.ValLat.data = this.dataVal;
      }
    });
    this.fechaSubcription = this.controlService.valFechaFiltro$.subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    this.DivVallatsub = this.diversificadorsv.valDivLatente$.pipe(auditTime(300)).subscribe({
      next: (data: any) => {
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.DivValLat.data = combinedata;
      }
    });
    this.DivfechaSubcription = this.diversificadorsv.valDivFechaFiltro$.subscribe({
      next: (data: any) => {
        console.log("desde DivfechaSubcription: ",data)
        this.scrollToFirstDate(data);
      }
    });
    //---------------GESTOR-----------------------
    this.gestFechaSub = this._gestorsv.valGestFechaFiltro$.subscribe({
      next: (data: any) => {
        console.log("desde Gestosr: ",data)
        this.scrollToFirstDate(data);
      }
    });
    this.gestValLatSub = this._gestorsv.valGestLatente$.pipe(auditTime(300)).subscribe({
      next: (data: any) => {
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.gestValLat.data = combinedata;
      }
    });
    //---------------------Broker ----------------------
    this.brokFechaSub = this._broker.valBrokFechaFiltro$.subscribe({
      next: (data: any) => {
        this.scrollToFirstDate(data);
      }
    });
    this.brokValLatSub = this._broker.valBrokLatente$.pipe(auditTime(300)).subscribe({
      next: (data: any) => {
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.brokValLat.data = combinedata;
      }
    });
    this.subTemaService = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => { this.isDark = data; }
    });
  }
  flattenArray(arrayOfArrays: any[]): any[] {

    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  // Asigna numlinea sobre el propio objeto: copiar cientos de miles de filas en cada lote
  // bloqueaba el navegador y duplicaba la memoria. Solo esta tabla consume estos streams.
  updateCounter(data: valorlatenteinterface[]): valorlatenteinterface[] {
    data.forEach((item: any) => {
      item.numlinea = item.contador != 0 ? item.contador : 'TOTAL';
    });
    return data;
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.selectedTab == 2) {

      if (this.index !== -1) {
        this.viewportValLat.scrollToIndex(this.index);
      }
       if (this.indexDiv !== -1) {
       
        this.viewportValLatDiv.scrollToIndex(this.indexDiv);
      }
      if (this.indexGest !== -1) {
        this.viewportValLatGest.scrollToIndex(this.indexGest);
      } 
      if (this.indexBrok !== -1) {
        this.viewportValLatBrok.scrollToIndex(this.indexBrok);
      }
    }
    this.actualizarViewport2();
  }

  actualizarViewport2() {
    if (this.viewportValLat) {
      this.viewportValLat.checkViewportSize();
      this.viewportValLat.checkViewportSize();
    } 
    if (this.viewportValLatDiv) {
      this.viewportValLatDiv.checkViewportSize();
      this.viewportValLatDiv.checkViewportSize();
    } 
    if (this.viewportValLatGest) {
      this.viewportValLatGest.checkViewportSize();
      this.viewportValLatGest.checkViewportSize();
    } 
    if (this.viewportValLatBrok) {
      this.viewportValLatBrok.checkViewportSize();
      this.viewportValLatBrok.checkViewportSize();
    }
  }

  scrollToFirstDate(date: string) {

    if (this.modelo) {
      this.index = this.ValLat.data.findIndex(item => item.fechaintervalo === date);
      if (this.index !== -1) {
        this.viewportValLat.scrollToIndex(this.index);
      }
    }
    else if (this.isPlanificador) {
      this.indexDiv = this.DivValLat.data.findIndex(item => item.fechaintervalo === date);
      if (this.indexDiv !== -1) {
        console.log("scrollToFirstDate this.indexDiv ",this.indexDiv)
        this.viewportValLatDiv.scrollToIndex(this.indexDiv);
      }
    }
    else if (this.isGestion) {
      this.indexGest = this.gestValLat.data.findIndex(item => item.fechaintervalo == date);
      if (this.indexGest !== -1) {
        this.viewportValLatGest.scrollToIndex(this.indexGest);
      }
    } else if (this.isBroker) {
      this.indexBrok = this.brokValLat.data.findIndex(item => item.fechaintervalo == date);
      if (this.indexBrok !== -1) {
        this.viewportValLatBrok.scrollToIndex(this.indexBrok);
      }
    }

  }

  selectRow(row: any) {
    this.filaSeleccionada = row;
    console.log(this.filaSeleccionada);
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    console.log(this.filaSeleccionada);
  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idnectum,
      nombreComp: this.filaSeleccionada.compania,
      idModelo: this.filaSeleccionada.idcartera.toString(),
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    window.open('/grafica-modelo/' + this.queryParams, '_blank');

  }
 
  verModelo() {
    console.log(this.filaSeleccionada);
    if (this.filaSeleccionada.idmodelo > 0) {
      const jsonData = {
        idNectum: this.filaSeleccionada.idnectum,
        nombreComp: this.filaSeleccionada.compania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      this.toastr.error('Selecciona correctamente el activo para ver modelo.', 'Aviso');
    }
  }



  ngOnDestroy(): void {
    this.valLatsubscription.unsubscribe();
    this.fechaSubcription.unsubscribe();
    this.DivVallatsub.unsubscribe();
    this.DivfechaSubcription.unsubscribe();
    this.gestFechaSub.unsubscribe();
    this.gestValLatSub.unsubscribe();
    this.brokFechaSub.unsubscribe();
    this.brokValLatSub.unsubscribe();
    this.subTemaService.unsubscribe();
  }


}
